import axios from 'axios'
import router from './src/router'
import { Notification } from 'element-ui'
import socket from './src/sockets'
const app = require('./src/main');

function errorResponseHandler(error) {
  if (error.response && error) {
    // console.log(error);
    if (error.response.request.responseURL.indexOf('/api/logs/frontLogs/create') == -1) {
      if (error.response.status === 401 || error.response.status === 408) {
        socket.disconnect();
        sessionStorage.clear();
        localStorage.clear();
        if (router.currentRoute.name !== 'login'){
          router.push({path: `/login`, query: {redirect: router.currentRoute.fullPath}});
        }
        Notification({title: 'Notification', message: app.app.$t('session_timeout'), type: "info"})
        // Notification({title: "Notification", message: "Session timeout", type: "info"})
        // var message = encodeURIComponent(JSON.stringify(error.response.data));
        // axios.get(`/api/logs/frontLogs/create?message=${message}`).catch(function() {
        //   console.log("ERROR")
        // })
      }else if(error.response.data.message == 'user_not_confirmed') {
        console.log('error.response.data', error.response.data.message);
        Notification({title: app.app.$t('notification_title_info'), message: app.app.$t('resend_confirm'), type: "info"})
        // Notification({title: "Info", message: "Resend Confirm", type: "info"})
      }
      // else if(error.response.data.message === 'active_project_task_timer_exists'){
      //   console.log('error.response.data', error.response.data.message);
      //   Notification({title: "Info", message: "Please pause or stop current active timer", type: "info"});
      // }
      else if(error.response.data.message === 'temp_shared_project_task_not_found'){
        console.log('error.response.data', error.response.data.message);
        Notification({title: app.app.$t('notification_title_info'), message: app.app.$t(error.response.data.message), type: "info"});
        // Notification({title: "Info", message: "Task sharing was canceled", type: "info"});
      }else if(error.response.data.message === 'vendor_invoice_counter_error'){
        console.log('error.response.data', error.response.data.data.items);
        Notification({title: "Cant Update Items", message: buildVendorInvoiceNotification(error.response.data.data.items), type: "info", dangerouslyUseHTMLString: true});
      }else if(error.response.data.message === 'user_not_exists_error') {
        console.log('error.response.data', error);
      }else{
        Notification({title: app.app.$t('notification_title_warning'), message: app.app.$t(error.response.data.message), type: "info"});
        // Notification({title: "Notification", message: error.response.data.message, type: "info"});
        console.log('error.response.data', error.response.data.message)
      }
    }
  }
  return Promise.reject(error)
}

function buildVendorInvoiceNotification(arr){
  return arr.map(val => `<p>Item: <strong>${val.name}</strong> Qty left: <i>${val.itemsLeft}</i></p>`).join('').toString();
}

// apply interceptor on response
axios.interceptors.response.use(
  response => response,
  errorResponseHandler
);

export default errorResponseHandler;

